import React from 'react'

import {StyledDashboardInnerCardTableCell} from '../../../GeneralDataCard.styled'
import {InputComponentProps} from './types'

import {Typography} from '~/components/general/typography/Typography'
import {Select, Option} from '~/components/general/select/Select'
import {Container} from '~/components/general/container/Container'

type SelectDataInputProps = InputComponentProps & {
  values: string[]
}

export const SelectDataInput: React.FC<SelectDataInputProps> = ({
  title,
  name,
  values,
  initialValue,
  onUpdate,
  required,
}) => {
  const [selectedValue, setSelectedValue] = React.useState<string>(
    initialValue || '',
  )

  const handleValueChange = (value: string) => {
    setSelectedValue(value)
    onUpdate([{name, value}])
  }
  return (
    <StyledDashboardInnerCardTableCell>
      <Container direction="column">
        <Typography weight="medium" size="sm" required={required} inline>
          {title}
        </Typography>
        <Select
          placeholder="Select"
          value={selectedValue}
          size="small"
          required={required && !selectedValue.trim()}>
          {values.map((value) => (
            <Option onClick={() => handleValueChange(value)} key={value}>
              <Typography weight="medium">{value}</Typography>
            </Option>
          ))}
        </Select>
      </Container>
    </StyledDashboardInnerCardTableCell>
  )
}
